import api from '@/api/request'

// 获得心跳数据
export function getBeatCollect(params) {
  return api.post(`/services/common/api/heartbeat/collection`, params)
}